import cn from 'classnames';

import { IConDefaultType } from '../../types';

export enum LoginIconVariant {
  DEFAULT = 'default',
}
export interface ILoginIconProps extends IConDefaultType {
  variant?: LoginIconVariant;
}

export default function LoginIcon({
  color,
  className,
  size = 20,
  rotate,
  flip,
  variant = LoginIconVariant.DEFAULT,
}: ILoginIconProps) {
  const style = {
    width: size,
    minWidth: size,
    height: size,
    transform: `rotate(${rotate}deg)`,
  };

  return (
    <i className={cn('dds-icon', className, { flip })} style={style}>
      {variant === LoginIconVariant.DEFAULT && (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
          <path
            d="M11.5 4H14.8333C15.2754 4 15.6993 4.14048 16.0118 4.39052C16.3244 4.64057 16.5 4.97971 16.5 5.33333V14.6667C16.5 15.0203 16.3244 15.3594 16.0118 15.6095C15.6993 15.8595 15.2754 16 14.8333 16H11.5"
            stroke="black"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9.33301 14.1673L13.4997 10.0007L9.33301 5.83398"
            stroke="black"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M13.5 10H3.5" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      )}
    </i>
  );
}
